import LogisticsCompany from "@/enum/LogisticsCompany";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import { doudianAxios, jushitaAxios } from "@/services/http/platformAxios";

export interface TbDeliverableCheckAddress {
    orderId: number;
    province: string;
    city: string;
    district: string;
    town: string;
    street: string;
}

interface GetTbAddressDeliverableParams {
    logisticsCompany: LogisticsCompany;

    addressesDtos: TbDeliverableCheckAddress[];
}

export interface DyAddressDeliverableShipperAddress {
    province: string;
    city: string;
    district: string;
    street: string;
}

export interface DyAddressDeliverableOrder {
    id: number;
    originalId: string;
    mergeSplitStatus: OrderMergeSplitStatus;
}

interface GetDyAddressDeliverableParams {
    shopId: number;
    shipperAddress: DyAddressDeliverableShipperAddress;
    orders: DyAddressDeliverableOrder[];
    logisticsCompany: LogisticsCompany;
}

export enum AddressDeliverable {
    DELIVERABLE = "DELIVERABLE",
    UN_DELIVERABLE = "UN_DELIVERABLE",
    UNKNOWN = "UNKNOWN",
}

export interface AddressDeliverableCheckResult {
    orderId: number;
    deliverable: AddressDeliverable;
}

/** 跨平台直接使用淘宝的接口 */

export function getTbAddressDeliverableCheck(
    params: GetTbAddressDeliverableParams,
): Promise<AddressDeliverableCheckResult[]> {
    return jushitaAxios.post("/address_deliverable/check", params);
}

export function getDyAddressDeliverableCheck(
    params: GetDyAddressDeliverableParams,
): Promise<AddressDeliverableCheckResult[]> {
    return doudianAxios.post("/address_deliverable/doudian", params);
}
